import { useEffect, useState } from "react";

export default function WebinarStickyRegister() {
  const [formInView, setFormInView] = useState(false);
  const [footerInView, setFooterInView] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  // Only start showing after user has scrolled down a little
  useEffect(() => {
    const onScroll = () => setHasScrolled(window.scrollY > 120);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Watch the registration form card and footer
  useEffect(() => {
    const formEl = document.getElementById("webinar-form");
    const footerEl = document.querySelector("footer");

    const formObs = new IntersectionObserver(
      ([entry]) => setFormInView(entry.isIntersecting),
      { threshold: 0.1 }
    );
    const footerObs = new IntersectionObserver(
      ([entry]) => setFooterInView(entry.isIntersecting),
      { threshold: 0.05 }
    );

    if (formEl) formObs.observe(formEl);
    if (footerEl) footerObs.observe(footerEl);

    return () => {
      formObs.disconnect();
      footerObs.disconnect();
    };
  }, []);

  const visible = hasScrolled && !formInView && !footerInView;

  const handleClick = () => {
    const el = document.getElementById("webinar-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-transform duration-300 ease-in-out ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      {/* White bar with soft top border + subtle blur */}
      <div className="bg-white/95 backdrop-blur-sm border-t border-gray-100 px-4 pt-3 pb-6">
        {/* Availability micro-signal */}
        <div className="flex items-center gap-2 mb-2.5">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse flex-shrink-0" />
          <span className="text-xs font-semibold text-green-600 whitespace-nowrap">
            Spots still available · April 15, 2026
          </span>
        </div>

        {/* CTA button */}
        <button
          onClick={handleClick}
          className="w-full bg-primary hover:bg-orange-600 text-white font-semibold text-sm py-3.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
        >
          Register Now — It&apos;s Free
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </button>
      </div>
    </div>
  );
}
